// @ts-ignore
import keyed from '../-x-ignore-tpl/keyed.js'
// @ts-ignore
import render from '../-x-ignore-tpl/renderer.js'
// @ts-ignore
import tpl from '../-x-ignore-tpl/tpl.js'
import {Component, define, Renderer, setRenderer} from './ignore.js'

setRenderer(render)

export {
  Component,
  define,
  keyed,
  render,
  Renderer,
  tpl,
}
